/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateRefundReceiptDto } from '../../models/create-refund-receipt-dto';
import { ReceiptDto } from '../../models/receipt-dto';

export interface ReceiptControllerUpdateNoScheduleRefund$Params {
  refundId: string;
      body: CreateRefundReceiptDto
}

export function receiptControllerUpdateNoScheduleRefund(http: HttpClient, rootUrl: string, params: ReceiptControllerUpdateNoScheduleRefund$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
  const rb = new RequestBuilder(rootUrl, receiptControllerUpdateNoScheduleRefund.PATH, 'patch');
  if (params) {
    rb.query('refundId', params.refundId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReceiptDto>;
    })
  );
}

receiptControllerUpdateNoScheduleRefund.PATH = '/api/receipt/refund/normal';
